import { object, string } from 'yup'

export type FormValues = {
  email: string
  firstName: string
  lastName: string
  company: string
  proficiencyInAI: string
  designation: string
  linkedIn: string
  teamSize: string
}

export const initialFormValues = {
  email: '',
  firstName: '',
  lastName: '',
  company: '',
  proficiencyInAI: '',
  designation: '',
  linkedIn: '',
  teamSize: ''
}

export const validationSchema = object().shape({
  email: string()
    .email('Please enter valid email address')
    .required('This field is required'),
  firstName: string().required('Please enter your first name'),
  lastName: string().required('Please enter your last name'),
  proficiencyInAI: string().required('Please select who you are'),
  linkedIn: string()
    .trim()
    .transform(value => {
      if (!value) return value
      const v = value.trim()
      return /^https?:\/\//i.test(v) ? v : `https://${v}`
    })
    .test('is-linkedin', 'Please enter a valid LinkedIn profile URL', value => {
      if (!value) return false
      try {
        const url = new URL(value)
        const host = url.hostname.toLowerCase()
        return (
          /(^|\.)linkedin\.com$/i.test(host) || /(^|\.)lnkd\.in$/i.test(host)
        )
      } catch {
        return false
      }
    })
    .required('Please enter your LinkedIn profile URL'),
  teamSize: string().required('Please select your team size'),
  company: string().required('Please enter your company name'),
  designation: string().required('Please enter your role')
})
